

























































































import { Component, Vue } from 'vue-property-decorator';

import StepDistributeBalanceWealthViewModel
  from '@/vue-app/view-models/components/flagship/flagship-link-goals/steps-wealth/step-distribute-balance-wealth-view-model';

@Component({ name: 'StepDistributeBalanceWealth' })
export default class StepDistributeBalanceWealth extends Vue {
  step_distribute_balance_wealth_model = Vue.observable(
    new StepDistributeBalanceWealthViewModel(this),
  );

  created() {
    this.step_distribute_balance_wealth_model.initialize();
  }
}
